import { LegalPage } from "./Privacy";

export default function Accessibility() {
  return (
    <LegalPage title="Accessibility" seoTitle="Accessibility Statement | First Responders Foundation" description="First Responders Foundation is committed to an accessible website for everyone, guided by WCAG 2.2 Level AA. Learn about our approach and how to report barriers." path="/accessibility" updated="October 22, 2026">
      <p>First Responders Foundation is committed to making this website usable by as many people as possible, including people with disabilities. We aim to follow the Web Content Accessibility Guidelines (WCAG) 2.2 at Level AA.</p>
      <h2>What we have done</h2>
      <ul>
        <li>Keyboard navigation throughout the site, with visible focus indicators and a skip-to-content link.</li>
        <li>Text and background colors chosen for readable contrast.</li>
        <li>Descriptive text alternatives for meaningful images.</li>
        <li>Form fields with clear labels, required-field indicators, and helpful error messages.</li>
        <li>A logical heading structure on every page.</li>
        <li>Reduced motion for visitors who have enabled that preference on their device.</li>
      </ul>
      <h2>Third-party content</h2>
      <p>Online donations are processed by Zeffy. While we select partners with care, we do not control the accessibility of third-party platforms.</p>
      <h2>Feedback</h2>
      <p>If you encounter a barrier on this website or need information in a different format, please let us know through the <a className="font-semibold text-navy underline" href="/about#contact">contact form</a>. We will do our best to respond promptly and provide the information you need.</p>
    </LegalPage>
  );
}
